import styled, { css } from 'styled-components';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { transparentize, lighten, darken } from 'polished';
import { HotKeys, configure } from 'react-hotkeys';
import { Img } from 'react-image';

interface TdProps {
  isIndisponivel?: boolean;
  $isGe?: boolean;
}
interface TrProps {
  rowselected: boolean;
  isIndisponivel?: boolean;
  $isGe?: boolean;
}
interface ScrollProps {
  height?: string;
}
interface DuracaoSelecionadaProps {
  warning: boolean;
}
configure({
  ignoreRepeatedEventsWhenKeyHeldDown: false,
  ignoreTags: [
    'input',
    'select',
    'textarea',
    'table',
    'tr',
    'td',
    'tbody',
    'thead',
  ],
  customKeyCodes: {
    32: 'SPACE_BAR',
  },
});

export const DuracaoSelecionada = styled.strong<DuracaoSelecionadaProps>`
  color: ${props =>
    props.warning ? props.theme.error : props.theme.fontColor};
`;

export const RightContent = styled.div`
  width: 80%;
  margin-left: 10px;
`;

export const LeftContent = styled.div`
  display: flex;
  height: calc(100vh - 89px);
  flex-direction: column;
  width: 100%;
  div {
    margin-bottom: 10px;

    &:last-of-type {
      margin-bottom: 0px;
    }
  }
`;

export const Container = styled(HotKeys)`
  display: flex;
  width: 100%;
`;

export const ModalAvaliacao = styled.div`
  button {
    margin: 3rem auto 0 auto;
  }
  textarea {
    margin-top: 2rem;
  }
  h3 {
    text-overflow: ellipsis;
    overflow: clip;
  }
`;

export const Table = styled.table`
  width: 100%;
  caret-color: transparent;

  border-collapse: collapse;

  thead {
    tr {
      th {
        text-align: left;
        padding: 10px 5px;

        color: ${props => props.theme.fontColor};
        font-size: 1.0625rem;
        font-weight: 600 !important;
      }
    }
  }
  tbody {
    td {
      padding: 5px 5px 5px 0px !important;
      font-size: 1.0625rem;
      color: ${props => props.theme.fontColor};
      strong {
        margin-left: 5px;
        font-size: 0.88rem;
        font-weight: normal;
        font-style: italic;

        &:before {
          content: '-';
          margin-right: 10px;
        }
      }
      button {
        margin: 0;
        &:hover {
          background-color: ${props => props.theme.hover};
        }
      }
    }
  }
`;

export const Tbody = styled.tbody``;

export const Tr = styled.tr<TrProps>`
  cursor: pointer;


${props =>
  props.rowselected
    ? props.$isGe && !props.isIndisponivel
      ? css`
          background: linear-gradient(
            0.25turn,
            rgba(0, 0, 0, 0),
            ${transparentize(0.5, props.theme.button.warn.in)}
          );
        `
      : !props.$isGe && props.isIndisponivel
      ? css`
          background: linear-gradient(
            0.25turn,
            rgba(0, 0, 0, 0),
            ${transparentize(0.5, props.theme.button.danger.out)}
          );
        `
      : props.$isGe && props.isIndisponivel
      ? css`
          background: linear-gradient(
            0.25turn,
            rgba(0, 0, 0, 0),
            ${transparentize(0.8, props.theme.button.danger.out)},
            ${transparentize(0.5, props.theme.button.warn.in)}
          );
        `
      : props.theme.name === 'dark'
      ? css`
          background: linear-gradient(
            0.25turn,
            rgba(0, 0, 0, 0),
            ${lighten(0.1, props.theme.cardBackgroud)}
          );
        `
      : css`
          background: linear-gradient(
            0.25turn,
            rgba(0, 0, 0, 0),
            ${darken(0.08, props.theme.cardBackgroud)};}
          );
        `
    : ``}

  border-bottom: 0.1px solid
    ${props =>
      props.theme.name === 'dark'
        ? transparentize(0.7, props.theme.fontColor)
        : transparentize(0.6, props.theme.fontColor)};

  &:last-of-type {
    border-bottom: none;
  }

  &:hover {
    transition: all 0.25s ease;
    background-color: ${props =>
      props.theme.name === 'dark'
        ? css`
            ${lighten(0.03, props.theme.cardBackgroud)};
          `
        : css`
            ${darken(0.03, props.theme.cardBackgroud)};
          `};
  }
`;

export const TdFlag = styled.td<TdProps>`
  font-size: 1.0625rem;
  color: ${props => props.theme.fontColor};

  div {
    margin-right: 5px;
    width: 10px;
    height: 40px;

    ${props =>
      props.$isGe && !props.isIndisponivel
        ? css`
            background: ${props.theme.button.warn.in};
          `
        : !props.$isGe && props.isIndisponivel
        ? css`
            background: ${props.theme.button.danger.out};
          `
        : props.$isGe && props.isIndisponivel
        ? css`
            background-image: linear-gradient(
              ${props.theme.button.danger.out},
              ${props.theme.button.warn.in}
            );
          `
        : ``}
  }
`;

export const Scroll = styled(PerfectScrollbar)<ScrollProps>`
  /* max-height: ${props => (props.height ? props.height : '35vh')}; */
  height: ${props => (props.height ? props.height : 'auto')};
  padding: 0px !important;

`;

export const CardContent = styled.div`
  display: flex;
  /* height: inherit; */
  flex-direction: column;
  padding: 0 15px;
  justify-content: flex-start;

  header {
    display: flex;
    flex-direction: row;
    padding: 0;
    align-items: center;
    justify-content: start;
    border-bottom: 1px solid
      ${props => transparentize(0.5, props.theme.fontColor)};
    h3 {
      font-size: 1.15rem;
      margin-right: 10px;
    }
  }
`;

export const SliderContent = styled.div`
  display: flex;
  flex-direction: column;
  header {
    display: flex;
    flex-direction: row;
    padding: 0;
    align-items: center;
    justify-content: start;
    border-bottom: 1px solid
      ${props => transparentize(0.5, props.theme.fontColor)};
    h3 {
      font-size: 1.15rem;
      margin-right: 10px;
    }
  }
`;

export const Controls = styled.div`
  display: flex;
  width: -webkit-fill-available;
  width: -moz-available;
  align-items: center;
  justify-content: center;
  background: ${props => props.theme.playerControls};
  border-radius: 10px;
  padding: 10px;
  margin: 5px;
  div {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const Infos = styled.div`
  display: flex;
  flex-direction: column;
  header {
    display: flex;
    flex-direction: row;
    padding: 0;
    align-items: center;
    justify-content: space-between !important;
    border-bottom: 1px solid
      ${props => transparentize(0.5, props.theme.fontColor)};
    h4 {
      /* font-size: 1.15rem; */
      margin-right: 10px;
      min-width: auto;
    }
  }
  div {
    display: flex;
    justify-content: space-between;
    div {
      display: flex;
      flex-direction: column;
      width: 100%;
      &:first-of-type {
        margin-right: 15px;
      }
      p {
        &:first-of-type {
          margin-top: 15px;
        }
        font-size: 0.95rem;
        font-weight: 400;
        strong {
          margin: 0 10px;
          font-weight: 600;
        }
      }
    }
  }
`;

export const CardHeader = styled.header`
  display: flex;
  flex-direction: row;
  align-items: center;

  div {
    display: flex;
    flex-direction: row;
    align-items: center;

    h4 {
      min-width: inherit !important;
      margin-right: 15px;
    }

    strong {
      font-size: 0.88rem;
      font-weight: normal;
      font-style: italic;
      opacity: 0.8;
    }
  }
`;

export const CardActions = styled.article`
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  header {
    display: flex;
    flex-direction: row;
    padding: 0;
    align-items: center;
    justify-content: start;
    border-bottom: 1px solid
      ${props => transparentize(0.5, props.theme.fontColor)};
    h3 {
      font-size: 1.15rem;
      margin-right: 10px;
    }
  }

  form {
    width: 100%;
    display: flex;
    flex-direction: column;

    p {
      margin-bottom: 10px;
    }
  }

  > div {
    display: grid;
    grid-template-rows: 1fr 1fr;
    grid-template-columns: 1fr 1fr;
    grid-gap: 5px 15px;
  }

  button {
    font-weight: 600;
  }
`;
export const Image = styled(Img)`
  img {
    /* width: 500px;
    min-width: 200px;
    height: auto;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.25s ease; */
  }
  &:hover {
    opacity: 0.7;
  }
`;

export const ThumbnailContainer = styled.div`
  flex: 1;
`;

export const MidiaInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-space-between;
  img {
    border-radius: 5px;
    width: 100%;
    min-width: 200px;
    height: auto;
    cursor: pointer;
  }
  ul {
    margin-left: 15px;
    display: flex;
    flex: 1;
    flex-direction: column;

    li {
      font-size: 0.9rem;

      display: flex;
      margin-top: 5px;
      align-items: center;
      justify-content: space-between;
      font-weight: 400;
      &:first-of-type {
        margin-top: 0;
      }

      /* para corrigir spacing line do ultimo item */
      &:last-of-type {
        margin-top: -5px;
      }
      strong {
        margin: 0 10px;
        font-weight: 400;
      }

      section {
        strong {
          margin: 0 !important;
        }
      }

      div {
        margin: 5px 0 5px;
      }

      button {
        margin-left: 3px;
      }
    }
  }
`;
